<ion-header class="ion-no-border">
  <ion-item *ngIf="accountHitMaxClient" color="danger">
    You've hit maximum of 50 clients.
  </ion-item>

  <ion-toolbar>
    <ion-buttons slot="start" *ngIf="modal">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title *ngIf="client">
      {{ client.id == undefined ? "Add a new client" : "Client details" }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="client">
  <form [formGroup]="clientForm">
    <ion-item lines="none">
      <ion-label position="stacked">First Name*</ion-label>
      <ion-input
        type="text"
        name=""
        formControlName="firstName"
        clearInput
        autofocus
        #firstNameInput
        *ngIf="client && !client.id"
        class="sm-input-border"
      ></ion-input>
      <ion-input
        type="text"
        name=""
        formControlName="firstName"
        clearInput
        #firstNameInput
        *ngIf="!client || client.id"
        class="sm-input-border"
      ></ion-input>
    </ion-item>
    <ion-item *ngIf="!firstName.valid && submitAttempt">
      <p *ngIf="firstName.hasError('required')" class="sm-error">
        Oops, a first name is required.
      </p>

      <p *ngIf="firstName.hasError('maxlength')" class="sm-error">
        A first name can't exceed 30 letters.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Last Name</ion-label>
      <ion-input
        type="text"
        name=""
        formControlName="lastName"
        clearInput
        class="sm-input-border"
      ></ion-input>
    </ion-item>
    <ion-item *ngIf="!lastName.valid && submitAttempt">
      <p *ngIf="lastName.hasError('maxlength')" class="sm-error">
        A last name can't exceed 35 letter.
      </p>
    </ion-item>
    <ion-item lines="none">
      <ion-label position="stacked">Pronouns</ion-label>
      <ion-select formControlName="pronouns" [interface]="'popover'">
        <ion-select-option
          *ngFor="let option of pronounOptions"
          [value]="option.value"
        >
          {{ option.name }}
        </ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item lines="none" [hidden]="pronouns.value != 4">
      <ion-label position="stacked">Enter Custom Pronouns</ion-label>
      <ion-input
        type="text"
        name="customPronouns"
        formControlName="customPronouns"
        clearInput
      ></ion-input>
    </ion-item>
    <ion-item *ngIf="!customPronouns.valid && submitAttempt">
      <p *ngIf="customPronouns.hasError('maxlength')" class="sm-error">
        Custom Pronouns can't exceed 30 letters.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Email</ion-label>
      <ion-input
        type="email"
        name="email"
        formControlName="email"
        clearInput
        (ionChange)="onEmailChange($event)"
        class="sm-input-border"
      ></ion-input>
    </ion-item>

    <ion-item *ngIf="email.pending">
      <ion-spinner icon="crescent" color="primary"></ion-spinner> Checking email
      availability...
    </ion-item>

    <ion-item *ngIf="!email.valid && email.hasError('clientEmailAvailability')">
      <p class="sm-error">Email already taken.</p>
    </ion-item>

    <ion-item *ngIf="!email.valid && submitAttempt">
      <p *ngIf="email.hasError('validateEmail')" class="sm-error">
        Oops, that email is invalid.
      </p>

      <p *ngIf="email.hasError('maxlength')" class="sm-error">
        An email can't exceed 100 characters.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Mobile Phone</ion-label>
      <ion-input
        type="tel"
        name=""
        formControlName="phone2"
        clearInput
        (ionChange)="onPhone2Change($event)"
        class="sm-input-border"
      ></ion-input>
    </ion-item>

    <ion-item *ngIf="!phone2.valid && submitAttempt">
      <p *ngIf="phone2.hasError('maxlength')" class="sm-error">
        Oops, this can't be longer than 20 characters.
      </p>
      <p *ngIf="phone2.hasError('validatePhone')" class="sm-error">
        Oops, this phone is invalid.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Home Phone</ion-label>
      <ion-input
        type="tel"
        name=""
        formControlName="phone1"
        clearInput
      ></ion-input>
    </ion-item>

    <ion-item *ngIf="!phone1.valid && submitAttempt">
      <p *ngIf="phone1.hasError('maxlength')" class="sm-error">
        Oops, this can't be longer than 20 characters.
      </p>
      <p *ngIf="phone1.hasError('validatePhone')" class="sm-error">
        Oops, this phone is invalid.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Work Phone</ion-label>
      <ion-input
        type="tel"
        name=""
        formControlName="workPh"
        clearInput
      ></ion-input>
    </ion-item>

    <ion-item *ngIf="!workPh.valid && submitAttempt">
      <p *ngIf="workPh.hasError('maxlength')" class="sm-error">
        Oops, this can't be longer than 20 characters.
      </p>
      <p *ngIf="workPh.hasError('validatePhone')" class="sm-error">
        Oops, this phone is invalid.
      </p>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Remind by</ion-label>
      <ion-select formControlName="reminderType" [interface]="'popover'">
        <ion-select-option
          *ngFor="let option of reminderOptions"
          [value]="option.value"
          [disabled]="option.disabled"
        >
          {{ option.label }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Notes</ion-label>

      <ion-textarea
        formControlName="notes"
        rows="5"
        class="smr-input-border"
      ></ion-textarea>
    </ion-item>

    <ng-container>
      <ion-item lines="none">
        <ion-label position="stacked">Address 1</ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="address1"
          clearInput
          class="smr-input-border"
        ></ion-input>
      </ion-item>

      <ion-item *ngIf="!address1.valid && submitAttempt">
        <p *ngIf="address1.hasError('maxlength')" class="sm-error">
          Oops, this can't be longer than 40 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked">Address 2</ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="address2"
          clearInput
          class="smr-input-border"
        ></ion-input>
      </ion-item>

      <ion-item *ngIf="!address2.valid && submitAttempt">
        <p *ngIf="address2.hasError('maxlength')" class="sm-error">
          Oops, this can't be longer than 40 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked">City</ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="city"
          clearInput
          class="smr-input-border"
        ></ion-input>
      </ion-item>

      <ion-item *ngIf="!city.valid && submitAttempt">
        <p *ngIf="city.hasError('maxlength')" class="sm-error">
          Oops, this can't be longer than 20 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked">Province</ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="province"
          clearInput
          class="smr-input-border"
        ></ion-input>
      </ion-item>

      <ion-item *ngIf="!province.valid && submitAttempt">
        <p *ngIf="province.hasError('maxlength')" class="sm-error">
          Oops, this can't be longer than 25 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked">Postal</ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="postal"
          clearInput
          class="smr-input-border"
        ></ion-input>
      </ion-item>

      <ion-item *ngIf="!postal.valid && submitAttempt">
        <p *ngIf="postal.hasError('maxlength')" class="sm-error">
          Oops, this can't be longer than 25 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked">Country</ion-label>
        <ion-select placeholder="Select a Country" formControlName="country">
          <ion-select-option
            *ngFor="let country of countries"
            [value]="country.getID()"
          >
            {{ country.getCountryName() }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item>
        <ion-label>Birthday</ion-label>
        <ion-datetime
          formControlName="birthdate"
          displayFormat="MMMM DD"
          (ionChange)="onBirthdateChange()"
        ></ion-datetime>
      </ion-item>

      <ion-item>
        <ion-label>Can book online</ion-label>
        <ion-toggle formControlName="canBookOnline"></ion-toggle>
      </ion-item>

      <ion-item>
        <ion-label>Subscribed to marketing emails</ion-label>
        <ion-toggle formControlName="subscriptionStatus"> </ion-toggle>
      </ion-item>
    </ng-container>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-no-padding">
    <ion-row>
      <ion-col>
        <ion-button
          color="primary"
          expand="block"
          ng-reflect-color="primary"
          (click)="onClientSave()"
          >Save</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
